import styled from '@emotion/styled';
import { captionM, captionSb, subTitle3, tag1M } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';
import Link from 'next/link';

import { DESKTOP } from '@/styles/themes';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 24px;
  ${DESKTOP} {
    padding: 32px;
    border-radius: 12px;
    border: 1px solid ${vars.neutral[80]};
  }
  * {
    margin: 0;
  }
`;

export const Title = styled.h4`
  ${subTitle3};
  color: ${vars.neutral[0]};
`;
export const RecommendList = styled.div``;
export const RecommendItem = styled(Link)`
  cursor: pointer;
`;
export const RecommendInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
`;
export const ThumbnailImgWrapper = styled.div`
  position: relative;
  width: 152px;
  height: 85px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
`;
export const RecommendTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const RecommendTitle = styled.p`
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  ${captionSb};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    ${captionM};
    color: ${vars.neutral[0]};
  }
`;
export const RecommendLecture = styled.p`
  ${tag1M};
  color: ${vars.neutral[50]};
`;
